<script lang="ts" setup>
    import { inject, onMounted, ref } from 'vue';
    import AppMenuAccountBalanceInfo from './AppMenuAccountBalanceInfo.vue';
    import AppMenuAccountChangeSettings from './AppMenuAccountChangeSettings.vue';
    import AppMenuAccountChangeLocaleAndTimeZone from './AppMenuAccountChangeLocaleAndTimeZone.vue';
    import AppMenuAccountChangePasswordDialog from './AppMenuAccountChangePasswordDialog.vue';
    import AppMenuAccountUploadDocumentsDialog from './AppMenuAccountUploadDocumentsDialog.vue';
    import AppMenuAccountDepositDialog from './AppMenuAccountDepositDialog.vue';
    import { useMenuStore } from '@/stores/menu';
    import { useUserStore } from '@/stores/user';
    import { useAppStore } from '@/stores/app';
    import { useDisplay, useTheme } from 'vuetify';
    import authService from '@/services/authService';
    import { Agent } from '@/constants';

    const depositDialogRef = ref<any>(null);
    const uploadDocumentsDialogRef = ref<any>(null);
    const changeOrderSettingsDialog = inject<any>('changeOrderSettingsDialogRef');
    const theme = useTheme();
    const display = useDisplay();
    const { t } = useI18n();

    const showDialog = (): void => {
        if (changeOrderSettingsDialog) {
            changeOrderSettingsDialog.value.open();
        }
    };

    const userStore = useUserStore();
    const menuStore = useMenuStore();
    const appStore = useAppStore();

    const showChangePasswordDialog = (): void => {
        changePasswordDialogRef.value.open();
    };

    const showUploadDocumentsDialog = (): void => {
        /*if (userStore.owner_id === Agent.Victor) {
            depositDialogRef.value.open();
        } else {
            uploadDocumentsDialogRef.value.open();
        }*/

        uploadDocumentsDialogRef.value.open();
    };

    const clickLogout = (): void => {
        authService.logout();
    };

    const changePasswordDialogRef = ref<any>(null);

    onMounted((): void => {
        console.log('Component app-menuAccountTB mounted.');
    });
</script>
<template>
    <v-menu v-model="menuStore.userMenu" :close-on-content-click="false" :nudge-width="200" offset="1px 175px">
        <template v-slot:activator="{ props }">
            <v-btn tag="a" class="link-menu" :height="display.xs.value ? 30 : 46" min-width="30" :width="display.xs.value ? 30 : 50" variant="text" v-bind="props" :data-tooltip="t('menu.account')">
                <v-icon size="24" :color="theme.name.value === 'dark' ? '' : '#867878'" :icon="mdiAccountBoxOutline" />
            </v-btn>
        </template>

        <v-card v-if="userStore.login" width="350px" variant="outlined">
            <v-list class="pt-0 pb-0 pr-0">
                <v-list-item class="pr-2">
                    <!--                    <v-list-item-content class="pl-2">-->
                    <v-list-item-title class="text-grey">
                        <div class="py-2" style="float: left">
                            &#60;
                            <span
                                class="bold font14 tbgreen-text"
                                style="
                                    font-family:
                                        consolas,
                                        menlo,
                                        ubuntu mono,
                                        fira code;
                                "
                            >
                                {{ userStore.login }}
                            </span>
                            /&#62;
                        </div>
                        <div class="mt-1" style="float: right">
                            <v-btn tag="a" icon class="link-menu" variant="plain" size="28" @click="clickLogout()">
                                <v-icon :data-tooltip="t('menu.logout')" size="24" :color="theme.name.value === 'dark' ? '' : '#867878'" :icon="mdiPower" />
                            </v-btn>
                        </div>
                    </v-list-item-title>
                    <!--                    </v-list-item-content>-->
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <AppMenuAccountBalanceInfo></AppMenuAccountBalanceInfo>

            <v-divider></v-divider>

            <AppMenuAccountChangeSettings></AppMenuAccountChangeSettings>

            <v-card-text class="py-2">
                <v-container class="font14 pl-4 pr-0">
                    <v-row>
                        <v-col cols="12" class="py-2 pl-1">
                            <span @click="showDialog" class="cursorPointer lightGreyText">
                                <v-icon style="margin-bottom: 2px" :icon="mdiCogOutline" />
                                {{ t('menu.orderSettings') }}
                            </span>
                        </v-col>

                        <v-col v-if="appStore.config.isDepositWithdrawalEnabled && userStore.ownerId !== Agent.Viktortb" cols="12" class="py-2 pl-1">
                            <span @click="showUploadDocumentsDialog" class="cursorPointer lightGreyText">
                                <v-icon style="margin-bottom: 2px" :icon="mdiCashFast" />
                                {{ t('menu.depositAndWithdrawals') }}
                            </span>
                        </v-col>

                        <v-col cols="12" class="py-2 pl-1">
                            <span @click="showChangePasswordDialog" class="cursorPointer lightGreyText">
                                <v-icon style="margin-bottom: 2px" :icon="mdiLockReset" />
                                {{ t('menu.changePassword') }}
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <AppMenuAccountUploadDocumentsDialog ref="uploadDocumentsDialogRef"></AppMenuAccountUploadDocumentsDialog>

            <AppMenuAccountDepositDialog ref="depositDialogRef"></AppMenuAccountDepositDialog>

            <AppMenuAccountChangePasswordDialog ref="changePasswordDialogRef"></AppMenuAccountChangePasswordDialog>

            <AppMenuAccountChangeLocaleAndTimeZone></AppMenuAccountChangeLocaleAndTimeZone>
        </v-card>
    </v-menu>
</template>
<style scoped>
    .v-theme--light.v-card--variant-outlined {
        border: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-theme--dark.v-card--variant-outlined {
        background-color: #1e1f22 !important;
        border: 1px solid #404148 !important;
    }
</style>
